import { get, post } from '../../../core/api/client';
import API_ENDPOINTS from '../../../core/api/endpoints';
import {
  clearAuthSession,
  getPersistedAuthToken,
  getPersistedAuthUser,
} from '../../../core/auth/authSession';

/**
 * @param {{ firstname, lastname, email, password, client_id }} params
 */
export const register = async ({ firstname, lastname, email, password, client_id }) => {
  return await post(
    API_ENDPOINTS.AUTH.REGISTER,
    { firstname, lastname, email, password, client_id },
    { skipAuth: true },
  );
};

/**
 * @param {{ email, password }} params
 */
export const login = async ({ email, password }) => {
  return await post(
    API_ENDPOINTS.AUTH.LOGIN,
    { email, password },
    { skipAuth: true },
  );
};

/**
 * @param {{ email, password, new_password }} params
 */
export const changePassword = async ({ email, password, new_password }) => {
  return await post(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, {
    email,
    password,
    new_password,
  });
};

/**
 * @param {{ email: string }} params
 */
export const requestResetPassword = async ({ email }) => {
  return await post(
    API_ENDPOINTS.AUTH.REQUEST_RESET_PASSWORD,
    { email },
    { skipAuth: true },
  );
};

/**
 * @param {{ email: string, token: string, new_password: string }} params
 */
export const resetPassword = async ({ email, token, new_password }) => {
  return await post(
    API_ENDPOINTS.AUTH.RESET_PASSWORD,
    { email, token, new_password },
    { skipAuth: true },
  );
};

/**
 * Sets the password for an invited user using the token from the invite email.
 * @param {{ email: string, token: string, new_password: string }} params
 */
export const setPassword = async ({ email, token, new_password }) => {
  return await post(
    API_ENDPOINTS.AUTH.SET_PASSWORD,
    { email, token, new_password },
    { skipAuth: true },
  );
};


export const getMe = async () => {
  return await get(API_ENDPOINTS.AUTH.ME);
};

/**
 * @param {{ email: string }} params
 */
export const setupTwoFa = async ({ email }) => {
  return await post(API_ENDPOINTS.AUTH.TWO_FA_SETUP, { email });
};

/**
 * @param {{ email: string, token: string, secret?: string, authToken?: string }} params
 */
export const verifyTwoFa = async ({ email, token, secret, authToken }) => {
  const payload = {
    email,
    token,
  };

  if (secret) {
    payload.secret = secret;
  }

  const requestOptions = authToken
    ? { headers: { Authorization: `Bearer ${authToken}` } }
    : undefined;

  return await post(API_ENDPOINTS.AUTH.TWO_FA_VERIFY, payload, requestOptions);
};

export const logout = () => {
  clearAuthSession();
};


export const getStoredUser = () => {
  return getPersistedAuthUser();
};

export const isAuthenticated = () => {
  return Boolean(getPersistedAuthToken());
};
